export default "__VITE_ASSET__DWhzWVDG__"